// extracted by mini-css-extract-plugin
export default {"preview":"_3NB23hS7s6TDVxFJWREyso"};